import { render, staticRenderFns } from "./EditRoutePlanning.vue?vue&type=template&id=4bbb6a96"
import script from "./EditRoutePlanning.vue?vue&type=script&lang=js"
export * from "./EditRoutePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports